import StatusHandler from 'app/shared-components/StatusHandler'
import useGetServiceCenterById from '../hooks/useGetServiceCenterById'

import WorkSchedule from './WorkSchedule'

const WorkScheduleContainer = ({
    id,
}: Readonly<{ id: number }>) => {
    const {
        data,
        isDataReady,
        isError,
        error,
        isFetching,
        invalidate,
    } = useGetServiceCenterById(id)

    return (
        <StatusHandler
            isSuccess={isDataReady && Boolean(data)}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <WorkSchedule
                data={{
                    operationalHours: data?.operationalHours,
                    breakStartsAt: data?.breakStartsAt,
                    breakEndsAt: data?.breakEndsAt,
                    isLunchBreak: Boolean(data?.breakStartsAt) && Boolean(data?.breakEndsAt),
                }}
                onSuccess={invalidate}
                id={id}
            />
        </StatusHandler>
    )
}

export default WorkScheduleContainer
